import { FaFacebook } from 'react-icons/fa'; // react-iconsを使ってFacebookアイコンを表示

const Footer: React.FC = () => {
  return (
    <footer className="bg-[#004d00] text-white py-6 mt-10">
      <div className="container mx-auto text-center">
        <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer">
          <FaFacebook className="inline-block text-2xl mb-5" />
        </a>
        <p className="mb-2">© 2024 Society for Ethno-Cultural Biology. All rights reserved.</p>
        <p className="mb-5">〒123-4567 TestAddress1-2-3</p>
        <p className="mt-2 text-sm">Developed by Tanesaka</p>
      </div>
    </footer>
  );
};

export default Footer;
